var React = require('react');

function Question (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 30c-.8 0-1.6-.6-1.6-1.6v-2c0-2 1.2-3.6 3-4.2 1.8-.6 3-2.4 3-4.2 0-1.2-.4-2.4-1.4-3.2-1-.8-1.8-1.026-3-1.026s-2.245.345-3.08 1.18c-.6.8-1.06 1.846-1.06 3.046 0 .8-.661 1.613-1.661 1.613S16.6 18.8 16.6 18c0-2.74.684-3.979 2.084-5.579C20.084 11.021 22 10.6 24 10.6s3.8.8 5.4 2.2c1.4 1.4 2.2 3.2 2.2 5.2 0 3.2-2 6-5 7-.6.2-1 .8-1 1.4v2c0 1-.8 1.6-1.6 1.6zm0 7.6c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.2-2.2 2.2z","key":0}),React.createElement("path",{"d":"M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm0-45C12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21S35.6 3 24 3z","key":1})]);
}

Question.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Question;

Question.default = Question;
